import $ from 'jquery';
import jsCookie from 'js-cookie';

export default function modalSection() {
	const $html = $('html');
	const $modal = $('#modal'), $video = $('#video-modal'), $popup = $('#newsletter-popup');
	// const $iframe = $modal.find('iframe');
	const toggler = $modal.data('toggler');

	if (toggler) {

		// $iframe.on('load', function() {
		// 	try {
		// 		const href = $iframe[0].contentWindow.location.href
		// 		const isBlank = href === 'about:blank';
		// 		toggler.toggle(!isBlank);
		//
		// 	} catch(e) {
		// 		toggler.close();
		// 	}
		// });

		// toggler.toggle(!isBlank);

		// openOnInit();

		if (!sessionStorage.getItem('seen-popup')) {
			openOnInit();
			sessionStorage.setItem('seen-popup', 'true');
		}

		function openOnInit() {
			setTimeout(function () {
				toggler.toggle(true);
			}, 5000);
		}

		$modal.on('click', function(e) {
			if (e.target === this) {
				toggler.close();
			}
		});

		toggler.on('toggle', function() {
			$html.toggleClass('is-modal-open', toggler.isOpen);
		});
	}

	if ($video.length) {
		const toggler = $video.data('toggler');
		const btn = $('#video-modal-button');
		const vid = $video.find('video')[0];

		$video.on('click', function(e) {
			if (e.target === this) {
				vid.stop();
				toggler.close();
			}
		});

		if (vid) {
			btn.click(function () {
				vid.play();
			});

			toggler.on('toggle', function() {
				if ($video.hasClass('is-closed') || $video.hasClass('is-closing')) {
					vid.pause();
				}
			});
		}
	}

	if ($popup.length) {
    const toggler = $popup.data('toggler');
    const setCookie = () => {
      jsCookie.set('newsletterPopup', true, { expires: 7 });
      toggler.close();
    }
    $popup.on('click', function(e) {
      if (e.target === this) {
        setCookie();
      }
    });

    $popup.find('#mc-embedded-subscribe').click(function() {
      setCookie();
    });

    $popup.find('.modal_close').click(function() {
      jsCookie.set('newsletterPopup', true, { expires: 7 });
    });

    if (!jsCookie.get('newsletterPopup')) {
			setTimeout(function () {
				toggler.toggle(true);
			}, $popup.data('popupDelay') * 1000);
    }
  }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/modal.js